// Angular
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeStyle, SafeScript, SafeUrl, SafeResourceUrl } from '@angular/platform-browser';

/**
 * Sanitize HTML
 */
@Pipe({
    name: 'safe',
    standalone: false,
})
export class SafePipe implements PipeTransform {
    /**
     * Pipe Constructor
     *
     * @param _sanitizer
     */
    // tslint:disable-next-line
    constructor(protected _sanitizer: DomSanitizer) {}

    /**
     * Transform
     *
     * @param value The value to sanitize / to bypass security trust
     * @param type The type of sanitization. What trust type shall be bypassed, e.g. 'html', 'script', etc. Default: 'html'
     * @returns The sanitized value
     */
    transform(
        value: string,
        type: 'html' | 'style' | 'script' | 'url' | 'resourceUrl' = 'html',
    ): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
        switch (type) {
            case 'html':
                return this._sanitizer.bypassSecurityTrustHtml(value);
            case 'style':
                return this._sanitizer.bypassSecurityTrustStyle(value);
            case 'script':
                return this._sanitizer.bypassSecurityTrustScript(value);
            case 'url':
                return this._sanitizer.bypassSecurityTrustUrl(value);
            case 'resourceUrl':
                return this._sanitizer.bypassSecurityTrustResourceUrl(value);
            default:
                return this._sanitizer.bypassSecurityTrustHtml(value);
        }
    }
}
